import * as amplitude from "@amplitude/analytics-browser";

// for initializing amplitude user
export const initializeAmplitudeUser = (userId, userProperties) => {
  if (import.meta.env.VITE_CUSTOM_NODE_ENV !== "production") return;

  const apiKey = import.meta.env.VITE_AMPLITUDE_API_KEY;

  if (!apiKey) return;

  amplitude
    .init(apiKey, userId, {
      autocapture: false,
    })
    .promise.then(() => setAmplitudeUserProperties(userProperties));
};

export const setAmplitudeUserProperties = (user) => {
  const userEmail = user?.email;

  const isBrandOwner = !user?.role?.key;
  const userRole = isBrandOwner ? "brand_owner" : user?.role?.key;

  setUserProperty("role", userRole);
  setUserProperty("email_id", userEmail);
};

export const setUserProperty = (propertyName, propertyValue) => {
  if (import.meta.env.VITE_CUSTOM_NODE_ENV !== "production") return;

  const identifyEvent = new amplitude.Identify();
  identifyEvent.set(propertyName, propertyValue);

  amplitude.identify(identifyEvent);
};

export const trackEvent = (eventName, eventProperties) => {
  if (import.meta.env.VITE_CUSTOM_NODE_ENV !== "production") return;

  amplitude.track(eventName, eventProperties);
};

export const resetAmplitude = () => amplitude.reset();
